import { useEffect, useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { Field, inputCls } from "./Field";

const Thumb = ({ file, onRemove, i }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  return (
    <div className="group relative aspect-square overflow-hidden border border-white/10">
      {url && <img src={url} alt={`Damage photo ${i + 1}`} className="h-full w-full object-cover" />}
      <button type="button" data-testid={`remove-photo-${i}`} onClick={onRemove} className="absolute right-1.5 top-1.5 grid h-7 w-7 place-items-center bg-ink/90 text-bone hover:bg-ember hover:text-ink">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export const StepProblem = ({ f, set, errors }) => {
  const input = useRef(null);
  const add = (files) => {
    const imgs = Array.from(files || []).filter((x) => x.type.startsWith("image/"));
    set("photos", [...f.photos, ...imgs].slice(0, 4));
  };
  return (
    <div className="space-y-8">
      <Field label="What's wrong?" hint="When did it start? Any drops, spills, error messages or noises?" error={errors.problem}>
        <textarea data-testid="problem-textarea" rows={6} className={`${inputCls} resize-none`} value={f.problem} onChange={(e) => set("problem", e.target.value)} placeholder="Describe the problem…" />
      </Field>
      <div>
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">Photos of the damage (optional, up to 4)</span>
        <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {f.photos.map((p, i) => (
            <Thumb key={`${p.name}-${i}`} file={p} i={i} onRemove={() => set("photos", f.photos.filter((_, j) => j !== i))} />
          ))}
          {f.photos.length < 4 && (
            <button
              type="button"
              data-testid="photo-upload-btn"
              onClick={() => input.current?.click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => { e.preventDefault(); add(e.dataTransfer.files); }}
              className="flex aspect-square flex-col items-center justify-center gap-2 border border-dashed border-white/20 text-slate-400 transition-colors hover:border-ember hover:text-ember"
            >
              <ImagePlus className="h-7 w-7" strokeWidth={1.25} />
              <span className="font-mono text-[11px] uppercase tracking-widest">Add photo</span>
            </button>
          )}
        </div>
        <input ref={input} data-testid="photo-file-input" type="file" accept="image/jpeg,image/png,image/webp,image/heic" multiple hidden onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
        {errors.photos && <p className="mt-2 text-xs text-red-400">{errors.photos}</p>}
      </div>
    </div>
  );
};
